import { FETCH_RESERVATIONS_SEARCH_RESULTS } from "../../../../../graphql/query/Reservation";
import { reservationFilterStore } from "../../../components/useReservationFilters";

const SearchedCompanies = () => {
  const tableProps = {
    dataKey: "reservationsV2",
    FETCH_QUERY: FETCH_RESERVATIONS_SEARCH_RESULTS,
    variables: {
      ...reservationFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedCompanies;
